import { inject, Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CreditSetupResponse, CreditSetupStatus, GlobalModalService } from '@brightside-web/desktop/data-access/shared';
import { CreditSetupService } from '@brightside-web/desktop/data-access/credit';
import {from, Observable, of, switchMap} from 'rxjs';
import { map } from 'rxjs/operators';
import { BsCacheService, SimpleGlobalModalService } from '@brightside-web/desktop/data-access/core-services';

@Injectable({
  providedIn: 'root',
})
export class InTermsGuard implements CanActivate {

  private _globalModalService = inject(SimpleGlobalModalService);

  constructor(
    private router: Router,
    private creditSetupService: CreditSetupService,
    private bsCacheService: BsCacheService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.creditSetupService.getSetupStatus().pipe(
      switchMap((resp: CreditSetupResponse) => {
        if (resp.status === CreditSetupStatus.TERMS_ACCEPTED) {
          return of(true);
        } else if (resp.status === CreditSetupStatus.VERIFICATION_FAILED) {
          return from(this.bsCacheService.getItem('ONBOARDING_FLOW_ACTIVE')).pipe(
            map(onboarding => {
              if (onboarding) {
                this._globalModalService.createModal({
                  title: 'ONBOARDING_ERROR_CREDIT_FAILED_TITLE',
                  headerImagePath: './assets/warning-exclamation.png',
                  contentKey: 'ONBOARDING_ERROR_CREDIT_FAILED_DESC',
                  displayCloseButton: false,
                  eventName: 'onboarding_credit_error',
                  isError: true,
                  size: 'medium',
                  ctaKey: 'BUTTON_CONTINUE',
                  ctaAction: () => {
                    this.router.navigate(['onboarding']).then(()=>{
                      this.creditSetupService.creditFailed.set(true);
                    });
                  },
                });
                return false;
                // return this.router.createUrlTree(['credit-setup', 'error-onboarding']);
              } else {
                return this.router.createUrlTree(['credit-setup', 'credit-setup-error']);
              }
            })
          );
        }
        return of(false);
      })
    );
  }
}
